import type { ThemeComponentType } from '../types';

export const Modal: ThemeComponentType = {
  defaultProps: {
    transitionDuration: 0,
    size: 'xl',
    overflow: 'inside',
  },
  styles: theme => ({
    header: {
      marginBottom: theme.other.spacing(1.5),
      marginRight: 0,
    },
    title: {
      ...theme.other.getFontSizeStyles('lg'),
      fontWeight: 600,
    },
    close: {
      color: '#808199',
    },
    body: {
      marginLeft: theme.other.spacing(-2),
      paddingLeft: theme.other.spacing(2),
      marginRight: theme.other.spacing(-2),
      paddingRight: theme.other.spacing(2),
      paddingBottom: theme.other.spacing(0.5),
    },
  }),
};
